type Props = {
  popupRef: React.RefObject<HTMLDivElement | null>;
  children: React.ReactNode;
};

export const CommentPopupMenuContainer: React.FC<Props> = ({ popupRef, children }: Props) => {
  return (
    <div ref={popupRef} role="menu" className="flex flex-col gap-2 rounded-xl bg-gray-700 p-2 text-3xl">
      {children}
    </div>
  );
};
